import React from "react";
import './Comment.css';

export const NoComments = () => {

    return (
        <div className="comment">
            <p>No Comments...</p>
        </div>
    )
}